import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { MapPin } from "lucide-react";

interface GrowingZoneFilterProps {
  onFilterChange?: (filters: {
    showMyZoneOnly: boolean;
  }) => void;
}

export const GrowingZoneFilter = ({ onFilterChange }: GrowingZoneFilterProps) => {
  const [showMyZoneOnly, setShowMyZoneOnly] = useState(false);

  const handleMyZoneToggle = (checked: boolean) => {
    setShowMyZoneOnly(checked);
    setTimeout(() => {
      onFilterChange?.({
        showMyZoneOnly: checked,
      });
    }, 0);
  };

  return (
    <Switch
      checked={showMyZoneOnly}
      onCheckedChange={handleMyZoneToggle}
      className="scale-75"
    />
  );
};